export const registration = (baseUrl: string): string => `${baseUrl}/notifications/v1/push/register`;
export const unregisterDevice = (baseUrl: string, deviceId: string): string =>
  `${baseUrl}/notifications/v1/push/unregister/${deviceId}`;
